PJQ.views.bidForms.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
	beforeFirstRender: function () {
		this.collection = new PJQ.collections.bidForms.Templates();
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	addTemplate: function () {
		new PJQ.views.templates.NewTemplateModal({
			model: new PJQ.models.bidForms.Template(),
			onSave: _.bind(function (template) {
				this.collection.add(template);
				this.editTemplate(template);
			}, this)
		});
	},
	editTemplate: function (template) {
		new PJQ.views.bidForms.EditTemplateModal({
			model: template,
			onClose: _.bind(function () {
				this.dataTable.refresh();
			}, this),
			onDelete: _.bind(function (template) {
				if (template.id > 0) {
					let row = this.dataTable.getRow(template.cid);
					this.collection.remove(template);
					template.destroy();
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.bidForms.SaveAsTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Save-As-Template'),
		maxWidth: 500
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		this.model = new PJQ.models.bidForms.Template({
			projectId: this.options.project.id
		});

		PJQ.app.session.fetchBidFormTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			new PJQ.inputs.AutocompleteInput({
				el: this.$('.input-template-name'),
				source: _.map(this.templates.models, function (template) {
					return template.get('name')
				})
			});
		}
	},
	save: function () {
		let $name = this.$('.input-template-name'),
			name = $name.val();
		if (_.size(name.trim()) === 0) {
			PJQ.helpers.inputHelpers.setInputError($name);
			return;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError($name, true);
		}

		let existingTemplate = this.templates.findWhere({name: name}),
			fnSave = _.bind(function () {
				this.model.save({
					name: name,
					groupIds: null
				}, {
					success: _.bind(function () {
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Form Template Created'
						});
					}, this)
				});
			}, this);
		if (existingTemplate != null) {
			new PJQ.views.modals.YesNo({
				header: "Overwrite Template",
				body: "A template already exists with this name.  Would you like to overwrite it?",
				onYes: _.bind(function () {
					this.model.set('templateId', existingTemplate.id);
					fnSave();
				}, this)
			});
		}
		else {
			fnSave();
		}
	}
});

PJQ.views.bidForms.ImportTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Import-Template'),
		maxWidth: 500,
		onImport: null
	},
	events: {
		'change .input-select-groups': 'filterGroups',
		'click .btn-import': 'save'
	},
	beforeModalCreated: function () {
		PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
			this.settings = settings;
			PJQ.app.session.fetchBidFormTemplates(_.bind(function (tmp) {
				this.templates = tmp;
				this.render();
			}, this));
		}, this))
	},
	renderData: function () {
		return {
			templates: this.templates != null && this.templates.isFetched ? _.filter(this.templates.models, _.bind(function (template) {
				return !this.settings.get('isUsingBidPackages') || template.get('bidPackageTemplateId') > 0;
			}, this)) : null,
			selectedTemplate: this.selectedTemplate
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			this.templatePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-template'),
				defaultValue: this.selectedTemplate ? this.selectedTemplate.id : null,
				onChange: _.bind(function (value) {
					this.selectedTemplate = this.templates.get(value);
					this.render();
				}, this),
				isIntChoices: true,
				noneSelectedText: 'Select Template'
			});

			if (this.selectedTemplate != null && !(this.selectedTemplate.get('bidPackageTemplateId') > 0)) {
				this.groupSelector = new PJQ.views.groups.GroupSelector({
					el: this.$('.group-selector')
				});
			}
		}
	},
	filterGroups: function () {
		let $sel = this.$('.group-selector');
		if (this.$('.input-select-groups').prop('checked')) {
			$sel.removeClass('hidden');
		}
		else {
			$sel.addClass('hidden');
		}
	},
	save: function () {
		let isValid = true;
		if (this.selectedTemplate == null) {
			this.templatePicker.showError();
			isValid = false;
		}
		else {
			this.templatePicker.hideError();
		}

		let selectedGroups = [];
		if (this.$('.input-select-groups').prop('checked')) {
			selectedGroups = this.groupSelector.getGroupsData().selected;
			if (_.size(selectedGroups) === 0) {
				this.groupSelector.showError("Select at least 1 group");
				isValid = false;
			}
			else {
				this.groupSelector.hideError();
			}
		}

		if (!isValid) {
			return;
		}

		this.settings.set('isUsingBidPackages', this.selectedTemplate.get('bidPackageTemplateId') > 0);

		if(this.settings.hasChanged()){
			this.settings.save(null, {
				success: _.bind(function() {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'projects',
								value: this.options.project.id
							},
							{
								endpoint: 'bidforms'
							},
							{
								endpoint: 'import',
								value: this.selectedTemplate.id
							}
						], [
							{
								parameter: 'overwrite',
								value: this.$('.input-overwrite').prop('checked')
							},
							{
								parameter: 'importProjectBidForm',
								value: this.$('.input-project-bid-form').prop('checked')
							}
						]),
						data: {
							ids: _.map(selectedGroups, function (group) {
								return group.id;
							})
						}
					}).put().done(_.bind(function (response) {
						if (typeof this.options.onImport === 'function') {
							let result = new PJQ.models.schedule.Schedule(response);
							result.isFetched = true;
							this.options.onImport(result, this.settings);
						}
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Form Template Imported'
						});
					}, this));
				}, this)
			});
		}
		else{
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.options.project.id
					},
					{
						endpoint: 'bidforms'
					},
					{
						endpoint: 'import',
						value: this.selectedTemplate.id
					}
				], [
					{
						parameter: 'overwrite',
						value: this.$('.input-overwrite').prop('checked')
					},
					{
						parameter: 'importProjectBidForm',
						value: this.$('.input-project-bid-form').prop('checked')
					}
				]),
				data: {
					ids: _.map(selectedGroups, function (group) {
						return group.id;
					})
				}
			}).put().done(_.bind(function (response) {
				if (typeof this.options.onImport === 'function') {
					let result = new PJQ.models.schedule.Schedule(response);
					result.isFetched = true;
					this.options.onImport(result, this.settings);
				}
				this.removeModal();
				PJQ.notifications.notify.successNotify({
					message: 'Bid Form Template Imported'
				});
			}, this));
		}
	}
});

PJQ.views.bidForms.EditTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Edit-Template'),
		maxWidth: '90%',
		onClose: null
	},
	events: {
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteTemplate'
	},
	beforeModalCreated: function () {
		this.listenTo(this.model, 'fetch', this.render);
		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (templates) {
			this.bidPackageTemplates = templates;
			this.model.fetch();
		}, this));
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model.isFetched) {
			new PJQ.inputs.TextEditorInput({
				el: this.$('.edit-template-name'),
				label: 'Name',
				value: this.model.get('name'),
				onSave: _.bind(function (value) {
					this.model.patch({
						name: value
					});
				}, this)
			});

			new PJQ.inputs.SelectPickerEditorInput({
				el: this.$('.edit-template-bid-package'),
				label: 'Bid Package Template',
				selectPickerOptions: {
					choices: _.map(this.bidPackageTemplates.models, function (template) {
						return {
							id: template.id,
							name: template.get('name')
						}
					}),
					isIntChoices: true
				},
				value: this.model.get('bidPackageTemplateId'),
				onSave: _.bind(function (value) {
					let fnSetPackage = _.bind(function () {
						this.model.patch({
							bidPackageTemplateId: value
						}, {
							success: _.bind(function (bidFormTemplate) {
								if (this.bidFormEditor) {
									this.bidFormEditor.collection = null;
									this.bidFormEditor.options.bidFormTemplate = bidFormTemplate;
									this.bidFormEditor.render();
								}
							}, this)
						});
					}, this)
					if (this.model.get('bidPackageTemplateId') == null) {
						new PJQ.views.modals.YesNo({
							header: "Assign Bid Package Template",
							body: "Are you sure you want to assign a Bid Package Template?  This action will remove all Trade Bid Forms from this Bid Form Template.  All existing line items, alternates, and acknowledgements will be moved to the corresponding Bid Package Bid Form if one exists.",
							onYes: _.bind(function () {
								fnSetPackage();
							}, this),
							onNo: _.bind(function () {
								if (this.bidFormEditor) {
									this.bidFormEditor.render();
								}
							}, this)
						});
					}
					else {
						fnSetPackage();
					}
				}, this)
			});

			this.bidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector({
				el: this.$('.manage-template'),
				bidFormTemplate: this.model
			});
		}
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
	},
	deleteTemplate: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});
